import { render } from "./AutoImport.vue?vue&type=template&id=3a5f0ee8&scoped=true"
import script from "./AutoImport.vue?vue&type=script&lang=js"
export * from "./AutoImport.vue?vue&type=script&lang=js"

import "./AutoImport.vue?vue&type=style&index=0&id=3a5f0ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5f0ee8"]])

export default __exports__